export default __webpack_public_path__ + "static/media/stacked-cards.3d80cc38.png";